<template>
  <div class="container-auditor">
    <div class="title">
      用印审批
    </div>
    <template v-for="(item, i) of signAuditor">
      <div class="item" :key="'signAuditor_0' + i">
        <div class="desc">
          <div>
            <img
              width="113px"
              :src="fileOperShow(item.seal)"
              :title="item.sealName"
            />
          </div>
          <div style="margin-left:30px">
            <p class="userName">{{ item.sealName }}</p>
            <p class="user-tilte-color">
              申请人：
            </p>
            <p class="userName">{{ item.initiateName }}</p>
            <p v-if="item.createTime">{{ item.createTime }}</p>
          </div>
        </div>
        <div class="chap" :class="status(item.signStatus)">
          <div class="chap-box">{{ statusText(item.signStatus) }}</div>
        </div>
      </div>
      <div class="content" :key="'signAuditor_' + i">
        <p class="tit">
          共{{ item.instPartyList.length }}方
          <span
            :style="{
              color: colorStatus(item),
              float: 'right',
              marginRight: '20px'
            }"
            >{{ allStatus(item) }}</span
          >
        </p>
        <div class="obj-box">
          <div
            class="obj"
            v-for="(v, index) in item.instPartyList"
            :key="index"
          >
            <template v-if="v.selfFlag">
              <el-tooltip
                effect="dark"
                :content="v.userName + '(我)'"
                placement="bottom"
              >
                <div class="user">
                  <span class="el-icon-user-solid"></span>
                </div>
              </el-tooltip>
            </template>
            <template v-else>
              <el-tooltip
                effect="dark"
                :content="v.userName"
                placement="bottom"
              >
                <div class="user">
                  <span class="el-icon-user-solid"></span>
                </div>
              </el-tooltip>
            </template>
            <div class="obj-other">
              <p class="userName">{{ v.userName }}</p>
              <div class="status text-color-green" v-if="v.flowStatus === 1">
                已同意
              </div>
              <div class="status text-color-red" v-if="v.flowStatus === 2">
                已驳回
              </div>
              <div class="status" v-if="v.flowStatus === 0">未审批</div>
              <div class="time" v-if="v.flowTime">{{ v.flowTime }}</div>
              <div class="reason" v-if="v.refuseReason">
                审批意见: {{ v.refuseReason }}
              </div>
            </div>
            <el-button
              plain
              class="approver-bth-sty"
              v-if="v.flowStatus === 0"
              type="primary"
              size="small"
              :disabled="!!(index > 0 && indexFlowStatus(item.instPartyList) !== index && v.orderNum)"
              @click="sendApproveSealSms(v.partyIdNo,item)"
            >催审</el-button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { fileOperShow } from "@/assets/js/http-serve/http-methods";
import {ApiCorpMethods} from "@/assets/js/http-serve/corp/http-methods";

export default {
  name: "audit-detail",
  props: {
    signAuditor: {
      type: Array,
      defualt: []
    }
  },
  data() {
    return {
      fileOperShow
    };
  },
  created() {},
  computed: {
    statusText() {
      return function(val) {
        let str = "";
        switch (val) {
          case 0:
            str = "未流转";
            break;
          case 1:
            str = "已通过";
            break;
          case 2:
            str = "未通过";
          default:
            break;
        }
        return str;
      };
    },
    status() {
      return function(val) {
        let str = "";
        switch (val) {
          case 0:
            str = "default";
            break;
          case 1:
            str = "suc";
            break;
          case 2:
            str = "fail";
          default:
            break;
        }
        return str;
      };
    }
  },
  mounted() {
  },
  methods: {
    /** 返回当前催审进度下标 */
    indexFlowStatus(users){
      const index = users.findIndex(user => user.flowStatus !== 1)
      return index
    },
    sendApproveSealSms (partyIdNo,item) {
      const {signNo,ts,sign} = this.$route.query
      const param={
        signNo:item.signNo,
        partyIdNo
      }
      // if (!signNo) {
      //   param.signNo = item.signNo
      // }
      ApiCorpMethods.CorpSealSignInfoController.flowApprovesealSms(param).then(res => {
        if (!res.success)
          return this.$message.error(res.description || this.$tip);
        this.$message.success("成功发送提醒通知");
      });
    },
    allStatus(item) {
      //0未审批1审批过2没审批通过3审批中
      if (item) {
        switch (item.flowStatus) {
          case 0:
            return "待审批";
            break;
          case 1:
            return "已通过";
            break;
          case 2:
            return "未通过";
            break;
          case 3:
            return "审批中";
            break;
          default:
            return "";
            break;
        }
      }
    },
    colorStatus(item) {
      //0未审批1审批过2没审批通过3审批中
      if (item) {
        switch (item.flowStatus) {
          case 1:
            return "#86DEA8";
          case 2:
            return "#EC1C1C";
          case 3:
            return "#FF9900";
          default:
            return "#000000";
        }
      }
    },
    /**
     * 自动换行
     * @param v 值
     * @param number
     */
    autoNewLine(v, number) {
      let d = "";
      for (let index = 0; index < v.length; index++) {
        const element = v[index];
        if (index > 0 && index % number === 0) {
          d += "\r\n";
        }
        d += element;
      }
      return d;
    }
  },
  beforeDestroy() {}
};
</script>
<style>
.el-tooltip__popper {
  max-width: 300px;
  white-space: normal;
  word-break: break-all;
}
</style>
<style scoped lang="less">
@import "../../assets/style/publicVar.css";
.user-tilte-color {
  color: var(--dark-color) !important;
}
.container-auditor {
  width: 100%;
  margin-top: 15px;
}

.container-auditor .item {
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  margin: 15px 0;
  padding: 15px;
  position: relative;

  .user {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    border: 1px solid #eeeeee;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    span {
      font-size: 32px;
      color: #eeeeee;
      border: 4px solid #eeeeee;
      border-radius: 50%;
    }
  }

  .chap {
    position: absolute;
    width: 75px;
    height: 75px;
    box-sizing: border-box;
    border: 2px solid transparent;
    border-radius: 50%;
    display: flex;
    top: -35px;
    right: 110px;
    align-items: center;
    justify-content: center;

    .chap-box {
      border-radius: 50%;
      border: 1px solid transparent;
      width: 62px;
      height: 62px;
      text-align: center;
      line-height: 62px;
      font-size: 16px;
      font-weight: bold;
      transform: rotate(315deg);
    }
  }

  .chap.suc {
    border-color: #86dea8;

    .chap-box {
      border-color: #86dea8;
      color: #86dea8;
    }
  }
  .chap.default {
    border-color: #dddddd;

    .chap-box {
      border-color: #dddddd;
      color: #dddddd;
    }
  }
  .chap.fail {
    border-color: #ec1c1c;

    .chap-box {
      border-color: #ec1c1c;
      color: #ec1c1c;
    }
  }

  .desc {
    width: auto;
    // height: 50px;
    display: flex;
    align-items: center;
    margin-left: 15px;

    p {
      font-size: 13px;
      color: #cccccc;

      span {
        margin-left: 20px;
      }
    }

    p.userName {
      color: #000000;
      font-size: 15px;
      font-weight: bold;
    }
  }
}

.container-auditor .content {
  width: 100%;
  // height: 560px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  padding: 10px 15px;
  .tit {
    height: 30px;
    line-height: 30px;
    width: 100%;
  }
  .obj-box {
    overflow: auto;
    overflow-x: hidden;
    position: relative;
    width: 100%;
    // height: 510px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .obj {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    min-height: 70px;
    height: auto;
    position: relative;
    margin-bottom: 30px;
    .approver-bth-sty{
        position: absolute;
        top: 30px;
        right: 16px;
      }
    &:not(:first-child) {
      /*border-top: 1px #eeeeee dashed;*/
      &:after {
        content: "";
        position: absolute;
        width: 640px;
        border: 1px #eeeeee dashed;
        height: 0px;
        top: -15px;
        left: 86px;
      }
      .user {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        border: 1px solid #eeeeee;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        span {
          font-size: 32px;
          color: #eeeeee;
          border: 4px solid #eeeeee;
          border-radius: 50%;
        }
      }
    }
    .user {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      border: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      span {
        font-size: 32px;
        color: #eeeeee;
        border: 4px solid #eeeeee;
        border-radius: 50%;
      }
    }
    .obj-other {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 70px;
      height: auto;
      margin-top: 10px;
      margin-left: 30px;
      .status {
        color: rgba(0, 0, 0, 0.65);
      }
      .text-color-red {
        color: red;
      }
      .text-color-green {
        color: #86dea8;
      }
      .reason {
        width: 640px;
        cursor: pointer;
      }
    }
  }
}

.title {
  width: 100%;
  font-weight: bold;
  font-size: 14px;

  .isOrder {
    font-size: 10px;
    padding: 2px 5px;
    color: #ffffff;
    background-color: #f0d092;
  }
}
</style>



// WEBPACK FOOTER //
// components/auditDetail/signApprove.vue